export default __webpack_public_path__ + "static/media/part_logo3.5e17a3c9.png";